import createTitleFabric from "../../../general/CoreHeader/components/Title/titleFabric";
import { createDisplayNameForHeaderSchevron } from "../../utils/createDisplayName";
import { createTestIdForHeaderSchevron } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderSchevron("Title");
const testId = createTestIdForHeaderSchevron("title");

const HeaderSchevronTitle = createTitleFabric(displayName, testId);

export default HeaderSchevronTitle;
